import { isEmpty } from 'lodash'

export default (searchedBy, filters, professional) => {
  if (!isEmpty(professional.id)) {
    filters['professional'] = professional
    searchedBy.push(professional.name)
  }
}



// WEBPACK FOOTER //
// ./src/app/patient/favorite-list/resources/filters/filterByProfessional.js